import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import moment from "moment";
import { DatePicker, TimePicker } from "antd";
import "antd/dist/antd.css";

export default function TicTacToeContest() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [searchSubType] = React.useState();
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [searchTourName, setSearchTourName] = React.useState();
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const TournamentSchema = Yup.object().shape({
    gameNo: Yup.number().required("required"),
    contestName: Yup.string().required("required"),
    betAmount: Yup.number().required("required"),
    bonusAmount: Yup.number().required("required"),
    repeatContest: Yup.string().required("required"),
    repeatTimeValue: Yup.string().required("required"),
    finishContestTime: Yup.string().required("required"),
    contestTime: Yup.string().required("required"),
    bot: Yup.number().required("required"),
    botComplexity: Yup.number().required("required"),
    minJoinPlayer: Yup.number().required("required"),
    maxJoinPlayer: Yup.number().required("required"),
    active: Yup.number().required("required"),
  });

  React.useEffect(() => {
    getTournamentData();
  }, []);

  const getTournamentData = () => {
    setLoader(true);
    axios(
      `${API_URL}/api/admin/contest-tournament/get-contest-tournament/${2}`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getTournamentData error :::", error);
      });
  };

  const searchingData = [];
  let data = [];
  console.log("tableData 111 ---", tableData, searchTourName);
  if (searchTourName) {
    console.log("tableData 222 ---", tableData, tableData.length > 0);
    data = tableData.filter((item) => {
      return Object.values(item?.contestName).join("").includes(searchTourName);
    });
    console.log("data 111 ---", data);
    data?.map((dataItem) => searchingData.push(dataItem));
  } else {
    tableData.map((dataItem) => searchingData.push(dataItem));
  }

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const updateTournament = (value) => {
    console.log(
      "updateTournament value :::",
      value,
      openValue,
      rowValue._id,
      rowValue
    );
    const margeData = { ...value, id: rowValue._id };
    console.log("margeData", margeData);
    axios
      .patch(
        `${API_URL}/api/admin/contest-tournament/update-contest-tournament/${rowValue._id}`,
        margeData
      )
      .then((res) => {
        console.log("update :::", res.data);
        const data = {
          message: "blockblast",
        };
        if (res.data.status) {
          successEdit();
          socket.emit("tournamentUpdate", data);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament value :::", value, openValue, rowValue);
    axios(
      `${API_URL}/api/admin/contest-tournament/add-contest-tournament
      `,
      {
        method: "POST",
        credentials: "include",
        data: value,
      }
    )
      .then((result) => {
        const data = {
          message: "blockblast",
        };
        if (result.data.status) {
          successAdd();
          socket.emit("tournamentAdd", data);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
      });
  };

  const warningWithConfirmMessage = (e) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Are you sure?"
        onConfirm={() => {
          deleteData(e);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      ></SweetAlert>
    );
  };

  const successDeleted = () => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Deleted!"
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          const data = {
            message: "blockblast",
          };

          socket.emit("tournamentDelete", data);
        }}
        confirmBtnBsStyle="success"
      >
        Your Tournament Record has been Deleted...
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e", e);
    axios
      .delete(
        `${API_URL}/api/admin/contest-tournament/delete-contest-tournament/${e._id}`,
        {
          id: e._id,
        }
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.status) {
          successDeleted();
        }
      });
  };

  const successAdd = () => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Added successfully!"
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        Your Tournament Record has been Added...
      </SweetAlert>
    );
  };

  const successEdit = () => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Edited successfully!"
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        Your Tournament Record has been Edited...
      </SweetAlert>
    );
  };

  const formateTime = (valueInSeconds) => {
    const duration = moment.duration(valueInSeconds, "seconds");
    const formattedTime = moment
      .utc(duration.asMilliseconds())
      .format("HH:mm:ss");
    return formattedTime;
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  gameNo: rowValue ? rowValue?.gameNo : 2,
                  contestName: rowValue ? rowValue?.contestName : "",
                  betAmount: rowValue ? rowValue?.betAmount : 0,
                  winPrizes: rowValue
                    ? rowValue.winPrizes
                    : [
                      {
                        minPlayer: 0,
                        maxPlayer: 0,
                        amount: 0,
                      },
                    ],
                  bonusAmount: rowValue ? rowValue?.bonusAmount : 0,
                  repeatTimeValue: rowValue
                    ? formateTime(rowValue?.repeatTimeValue)
                    : "",
                  contestTime: rowValue ? rowValue?.contestTime : "",
                  finishContestTime: rowValue
                    ? rowValue?.finishContestTime
                    : "",
                  bot: rowValue ? rowValue?.bot : 0,
                  botComplexity: rowValue ? rowValue?.botComplexity : 0,
                  minJoinPlayer: rowValue ? rowValue?.minJoinPlayer : 0,
                  maxJoinPlayer: rowValue ? rowValue?.maxJoinPlayer : 0,
                  repeatContest: rowValue ? rowValue?.repeatContest : "",
                  active: rowValue ? rowValue?.active : 0,
                }}
                validationSchema={TournamentSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log("update formik value :::", values, openValue);
                  if (openValue == 1) {
                    setbuttonLoader(false);
                    addNewTournament(values);
                  }
                  if (openValue == 2) {
                    setbuttonLoader(false);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                  <div>
                    <Form>
                      <div className="form-group">
                        <label htmlFor="password">Game No</label>
                        <Field
                          type="number"
                          name="gameNo"
                          placeholder="Game No"
                          disabled
                          className={`mt-2 form-control
                          ${touched.gameNo && errors.gameNo ? "is-invalid" : ""
                            }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="gameNo"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Contest Name</label>
                        <Field
                          type="text"
                          name="contestName"
                          placeholder="Contest Name"
                          className={`mt-2 form-control
                          ${touched.contestName && errors.contestName
                              ? "is-invalid"
                              : ""
                            }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="contestName"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="password">Bet Amount</label>
                        <Field
                          type="number"
                          name="betAmount"
                          placeholder="Bet Amount"
                          className={`mt-2 form-control
                          ${touched.betAmount && errors.betAmount
                              ? "is-invalid"
                              : ""
                            }`}
                          onChange={(e) => {
                            const re = /^[0-9]*\.?[0-9]*$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              setFieldValue("betAmount", e.target.value);
                            }
                          }}
                        />
                        <ErrorMessage
                          component="div"
                          name="betAmount"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Bonus Amount</label>
                        <Field
                          type="number"
                          name="bonusAmount"
                          placeholder="Bonus Amount"
                          className={`mt-2 form-control
                          ${touched.bonusAmount && errors.bonusAmount
                              ? "is-invalid"
                              : ""
                            }`}
                          onChange={(e) => {
                            const re = /^[0-9]*\.?[0-9]*$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              setFieldValue("bonusAmount", e.target.value);
                            }
                          }}
                        />
                        <ErrorMessage
                          component="div"
                          name="bonusAmount"
                          className="invalid-feedback"
                        />
                      </div>

                      <FieldArray
                        name="winPrizes"
                        render={(arrayHelpers) => (
                          <div>
                            {values.winPrizes.map((winPrizes, index) => (
                              <div key={index}>
                                {/* <Field name={`winPrizes.${index}`} /> */}
                                <div className="form-group">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {index == 0 && (
                                      <label
                                        htmlFor="password"
                                        className="mt-3"
                                      >
                                        WinPrizes
                                      </label>
                                    )}
                                    {index == 0 && (
                                      <button
                                        className="btn btn-primary m-1 "
                                        type="button"
                                        onClick={() =>
                                          arrayHelpers.insert(index, "")
                                        } // insert an empty string at a position
                                      >
                                        +
                                      </button>
                                    )}
                                  </div>

                                  <div className="d-flex">
                                    <Field
                                      type="number"
                                      name={`winPrizes[${index}].minPlayer`}
                                      placeholder="minPlayer"
                                      // disabled={
                                      //   accessObject?.bonusEdit == true ? false : true
                                      // }
                                      className={` form-control`}
                                    />
                                    <Field
                                      type="number"
                                      name={`winPrizes[${index}].maxPlayer`}
                                      placeholder="maxPlayer"
                                      // disabled={
                                      //   accessObject?.bonusEdit == true ? false : true
                                      // }
                                      className={` form-control`}
                                    />
                                    <Field
                                      type="number"
                                      name={`winPrizes[${index}].amount`}
                                      placeholder="amount"
                                      // disabled={
                                      //   accessObject?.bonusEdit == true ? false : true
                                      // }
                                      className={` form-control`}
                                    />
                                    <button
                                      className="btn btn-danger mx-1"
                                      type="button"
                                      disabled={values.winPrizes.length == 1}
                                      onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      />

                      <div className="form-group">
                        <label htmlFor="password">Bot</label>
                        <Field
                          as="select"
                          name="bot"
                          className={`mt-2 form-control
                          ${touched.bot && errors.bot ? "is-invalid" : ""}`}
                        >
                          <option value={1}>OFF</option>
                          <option value={0}>ON</option>
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="bot"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Bot Complexity</label>
                        <Field
                          as="select"
                          name="botComplexity"
                          className={`mt-2 form-control
                          ${touched.botComplexity && errors.botComplexity
                              ? "is-invalid"
                              : ""
                            }`}
                        >
                          <option value={0}>Easy</option>
                          <option value={1}>Medium</option>
                          <option value={2}>Hard</option>
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="botComplexity"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Min Join Player</label>
                        <Field
                          type="number"
                          name="minJoinPlayer"
                          placeholder="minJoinPlayer"
                          className={`mt-2 form-control
                          ${touched.minJoinPlayer && errors.minJoinPlayer
                              ? "is-invalid"
                              : ""
                            }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="minJoinPlayer"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Max Join Player</label>
                        <Field
                          type="number"
                          name="maxJoinPlayer"
                          placeholder="maxJoinPlayer"
                          className={`mt-2 form-control
                          ${touched.maxJoinPlayer && errors.maxJoinPlayer
                              ? "is-invalid"
                              : ""
                            }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="maxJoinPlayer"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Repeat Contest</label>
                        <Field
                          as="select"
                          name="repeatContest"
                          className={`mt-2 form-control
                          ${touched.repeatContest && errors.repeatContest
                              ? "is-invalid"
                              : ""
                            }`}
                          defaultValue=""
                        >
                          <option value="">Select...</option>
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="repeatContest"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="time">Repeat Time</label>
                        <Field name="repeatTimeValue">
                          {({ field }) => (
                            <TimePicker
                              style={{ borderRadius: "0.25rem" }}
                              format="HH:mm:ss"
                              className={`mt-2 form-control ${touched.repeatTimeValue &&
                                  errors.repeatTimeValue
                                  ? "is-invalid"
                                  : ""
                                }`}
                              onChange={(time, timeString) => {
                                setFieldValue("repeatTimeValue", timeString);
                              }}
                              defaultValue={
                                field.value
                                  ? moment.utc(field.value, "HH:mm:ss")
                                  : null
                              }
                            />
                          )}
                        </Field>

                        <ErrorMessage
                          component="div"
                          name="repeatTimeValue"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Contest Time</label>
                        <Field name="contestTime">
                          {({ field }) => (
                            <DatePicker
                              showTime
                              className={`mt-2 form-control ${touched.contestTime && errors.contestTime
                                  ? "is-invalid"
                                  : ""
                                }`}
                              style={{ borderRadius: "0.25rem" }}
                              onChange={(date, dateString) => {
                                setFieldValue("contestTime", dateString);
                              }}
                              defaultValue={
                                field.value ? moment.utc(field.value) : null
                              }
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="contestTime"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Finish ContestTime</label>
                        <Field name="finishContestTime">
                          {({ field }) => (
                            <DatePicker
                              showTime
                              className={`mt-2 form-control ${touched.finishContestTime &&
                                  errors.finishContestTime
                                  ? "is-invalid"
                                  : ""
                                }`}
                              style={{ borderRadius: "0.25rem" }}
                              onChange={(date, dateString) =>
                                setFieldValue("finishContestTime", dateString)
                              }
                              defaultValue={
                                field.value ? moment.utc(field.value) : null
                              }
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="finishContestTime"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Active</label>
                        <Field
                          as="select"
                          name="active"
                          className={`mt-2 form-control
                          ${touched.active && errors.active ? "is-invalid" : ""
                            }`}
                        >
                          <option value={1}>OFF</option>
                          <option value={0}>ON</option>
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="active"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="d-flex">
                        <button
                          style={{ width: "100px" }}
                          type="submit"
                          className="btn btn-primary btn-block mt-4 mr-2"
                          disabled={buttonLoader}
                        >
                          <div
                            className="d-flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="d-flex"
                              style={{
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <b>Submit</b>
                            </div>
                            {buttonLoader && (
                              <div>
                                <div
                                  class="spinner-border ml-2 mt-1"
                                  role="status"
                                  style={{ height: "20px", width: "20px" }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </button>
                        <button
                          style={{ width: "100px" }}
                          onClick={() => setShowPage(false)}
                          type="button"
                          className="btn btn-secondary btn-block mt-4 ms-2"
                        >
                          Close
                        </button>
                      </div>
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            <div class="pl-4 pr-4 pt-4">
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  {accessObject?.addBlockBlastTour == true && (
                    <>
                      <button
                        style={{ width: "118px" }}
                        onClick={() => {
                          openAddTournament(1);
                        }}
                        type="button"
                        className="btn btn-primary btn-block "
                      >
                        <AddIcon />
                        Add New
                      </button>
                    </>
                  )}
                </div>
                <div className="mt-2 col-md-6 col-lg-6 d-flex justify-content-start justify-content-lg-end">
                  <div>
                    <input
                      class="input-simple"
                      type="text"
                      placeholder="Contest Name"
                      value={searchSubType}
                      onChange={(e) => setSearchTourName(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Contest Name</th>
                    <th>Bet Amount</th>
                    <th>Min Join Player</th>
                    <th>Max Join Player</th>
                    <th>Bot</th>
                    <th>Bot Complexity</th>
                    <th>Active</th>
                    {(accessObject?.editBlockBlastTour == true ||
                      accessObject?.deleteBlockBlastTour == true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getBlockBlastTour == true ? (
                    <>
                      {!loader ? (
                        <>
                          {searchingData.length > 0 ? (
                            <>
                              {searchingData
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td style={{ textAlign: "center" }}>
                                        {moment(item.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>{item.contestName}</td>
                                      <td>{item.betAmount}</td>
                                      <td>{item.minJoinPlayer}</td>
                                      <td>{item.maxJoinPlayer}</td>
                                      <td>{item.bot}</td>
                                      <td>{item.botComplexity}</td>
                                      <td>{item.active}</td>
                                      {(accessObject?.editBlockBlastTour ==
                                        true ||
                                        accessObject?.deleteBlockBlastTour ==
                                        true) && (
                                          <td className="justify-content-evenly ">
                                            <div className="d-flex">
                                              {accessObject?.editBlockBlastTour ==
                                                true && (
                                                  <EditIcon
                                                    className="mr-3 courser"
                                                    onClick={() =>
                                                      clickEditButton(item)
                                                    }
                                                  />
                                                )}
                                              {accessObject?.deleteBlockBlastTour ==
                                                true && (
                                                  <ClearIcon
                                                    className="courser text-danger"
                                                    onClick={() =>
                                                      warningWithConfirmMessage(
                                                        item
                                                      )
                                                    }
                                                  />
                                                )}
                                            </div>
                                          </td>
                                        )}
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <>
                              <tr
                                style={{ backgroundColor: "whitesmoke" }}
                                className="text-center"
                              >
                                <td colSpan={14}>
                                  <h5>No Data Available</h5>
                                </td>
                              </tr>
                            </>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={14} className="p-3">
                        <h5 className="text-center mb-0">Access Denied</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {accessObject?.getBlockBlastTour == true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getBlockBlastTour == true &&
              searchingData.length != 0 && (
                <Pagination
                  updateShowPerpagevalue={updateShowPerpagevalue}
                  showPrePage={showPrePage}
                  onPaginationChange={onPaginationChange}
                  total={searchingData.length}
                />
              )}
          </div>
        </div>
      )}
    </>
  );
}
